import React from "react";

const Overview = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M10.125 3H4.875C4.39175 3 4 3.50368 4 4.125V10.875C4 11.4963 4.39175 12 4.875 12H10.125C10.6082 12 11 11.4963 11 10.875V4.125C11 3.50368 10.6082 3 10.125 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.125 3H14.875C14.3918 3 14 3.27982 14 3.625V7.375C14 7.72018 14.3918 8 14.875 8H20.125C20.6082 8 21 7.72018 21 7.375V3.625C21 3.27982 20.6082 3 20.125 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.125 15H4.875C4.39175 15 4 15.2798 4 15.625V19.375C4 19.7202 4.39175 20 4.875 20H10.125C10.6082 20 11 19.7202 11 19.375V15.625C11 15.2798 10.6082 15 10.125 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.125 11H14.875C14.3918 11 14 11.5037 14 12.125V18.875C14 19.4963 14.3918 20 14.875 20H20.125C20.6082 20 21 19.4963 21 18.875V12.125C21 11.5037 20.6082 11 20.125 11Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Overview;
